import React from "react";
import logo from '../assets/sanjivni ayurveda logo.png'
const WHY_CHOOSE = [
  {
    icon: "🌿",
    title: "100% Natural Ingredients",
    desc: "Every product is crafted from sustainably sourced herbs and botanicals, free from harmful chemicals and artificial additives.",
  },
  {
    icon: "🔬",
    title: "Lab-Tested & GMP Certified",
    desc: "Our formulations undergo rigorous third-party laboratory testing to ensure purity, potency, and safety in every batch.",
  },
  {
    icon: "📜",
    title: "Ancient Wisdom, Modern Science",
    desc: "We blend 5,000 years of Ayurvedic tradition with contemporary research to deliver effective, evidence-informed remedies.",
  },
  {
    icon: "🤝",
    title: "Trusted by Thousands",
    desc: "Over 50,000 customers across India trust Sanjivani Ayurveda for their daily wellness journey — and we honour that trust every day.",
  },
];

const TEAM = [
  { emoji: "👨‍⚕️", name: "K.J. Shukla", role: "Chief Ayurvedic Physician" },
  { emoji: "👨‍⚕️", name: "Nikanth Shukla", role: "Head of Research & Formulation" },
  { emoji: "👩‍🔬", name: "Falguni K Shukhla", role: "Sustainability & Sourcing Lead" },
];

export default function About() {
  return (
    <>
      <style>{css}</style>

      {/* PAGE HEADER */}
      <header className="products-header">
        <div className="products-header__bg" aria-hidden="true" />
        <div className="container">
          <span className="products-header__eyebrow">✦ Our Story</span>
          <h1 className="products-header__title">About Sanjivani Ayurveda</h1>
          <p className="products-header__sub">Rooted in tradition · Driven by science · Committed to you</p>
        </div>
      </header>

      <div className="container about-layout">

        {/* INTRO */}
        <section className="about-intro">
          <div className="about-intro__img-wrap" aria-hidden="true">
            <span className="about-intro__emoji"><img src={logo} alt="" /></span>
          </div>
          <div className="about-intro__text">
            <span className="about-eyebrow">Who We Are</span>
            <h2 className="about-section-title">Healing Through Nature</h2>
            <p className="about-body">
              Sanjivani Ayurveda was founded with a singular vision: to make authentic, high-quality Ayurvedic wellness accessible to every household in India and beyond. Born in the heartland of Gujarat, our journey began in a small family dispensary and has grown into a trusted wellness brand serving over 50,000 customers across 20 states.
            </p>
            <p className="about-body" style={{ marginTop: 14 }}>
              Every product we create carries the expertise of qualified Ayurvedic practitioners, the rigour of modern laboratory testing, and the warmth of a family that genuinely cares about your wellbeing. We believe that true health is holistic — mind, body, and spirit — and our entire range is designed with that philosophy at its core.
            </p>
            <div className="about-stats">
              {[["50K+", "Happy Customers"], ["200+", "Products"], ["18+", "Years of Trust"], ["100%", "Natural"]].map(([n, l]) => (
                <div className="about-stat" key={l}>
                  <span className="about-stat__num">{n}</span>
                  <span className="about-stat__label">{l}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* MISSION & VISION */}
        <section className="mv-grid">
          <div className="mv-card">
            <div className="mv-card__icon">🎯</div>
            <h3 className="mv-card__title">Our Mission</h3>
            <p className="mv-card__body">
              To democratise authentic Ayurvedic wellness by making pure, effective, and affordable herbal products available to every individual — empowering people to take charge of their health through the timeless wisdom of nature.
            </p>
          </div>
          <div className="mv-card mv-card--accent">
            <div className="mv-card__icon">🔭</div>
            <h3 className="mv-card__title">Our Vision</h3>
            <p className="mv-card__body">
              To be India's most trusted Ayurvedic wellness brand, recognised globally for uncompromising quality, sustainable practices, and a genuine commitment to improving lives through the science of holistic living.
            </p>
          </div>
        </section>

        {/* WHY CHOOSE US */}
        <section className="about-section">
          <div className="about-section-header">
            <span className="about-eyebrow">Why Choose Us</span>
            <h2 className="about-section-title">The Sanjivani Difference</h2>
          </div>
          <div className="why-grid">
            {WHY_CHOOSE.map((item, i) => (
              <div className="why-card" key={i} style={{ "--delay": `${i * 0.08}s` }}>
                <div className="why-card__icon">{item.icon}</div>
                <h4 className="why-card__title">{item.title}</h4>
                <p className="why-card__desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* TEAM */}
        <section className="about-section">
          <div className="about-section-header">
            <span className="about-eyebrow">Our Team</span>
            <h2 className="about-section-title">The Experts Behind Sanjivani</h2>
          </div>
          <div className="team-grid">
            {TEAM.map((m, i) => (
              <div className="team-card" key={i}>
                <div className="team-card__avatar">{m.emoji}</div>
                <h4 className="team-card__name">{m.name}</h4>
                <span className="team-card__role">{m.role}</span>
              </div>
            ))}
          </div>
        </section>

      </div>
    </>
  );
}

const css = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=Jost:wght@300;400;500;600&display=swap');

:root {
  --c-primary:       #2d6a4f;
  --c-primary-light: #40916c;
  --c-primary-dark:  #1b4332;
  --c-accent:        #d4a017;
  --c-bg:            #f9f6f0;
  --c-surface:       #ffffff;
  --c-text:          #1c2b22;
  --c-muted:         #5a7262;
  --c-border:        #d4e6d5;
  --f-display:       'Cormorant Garamond', Georgia, serif;
  --f-body:          'Jost', sans-serif;
  --radius:          14px;
  --shadow:          0 4px 24px rgba(27,67,50,.09);
  --shadow-lg:       0 12px 40px rgba(27,67,50,.15);
  --ease:            cubic-bezier(.4,0,.2,1);
}

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
body { font-family: var(--f-body); background: var(--c-bg); color: var(--c-text); }
.container { max-width: 1160px; margin: 0 auto; padding: 0 24px; }
.btn-primary {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  font-family: var(--f-body); font-size: .82rem; font-weight: 600;
  letter-spacing: .07em; text-transform: uppercase;
  padding: 12px 28px; border-radius: 100px; border: none;
  background: var(--c-primary); color: #fff; cursor: pointer;
  transition: background .22s, transform .22s;
}
.btn-primary:hover:not(:disabled) { background: var(--c-primary-dark); transform: translateY(-1px); }
.btn-primary:disabled { opacity: .7; cursor: not-allowed; }
.products-header {
  position: relative; overflow: hidden;
  padding: 100px 0 50px;
  background: linear-gradient(135deg, var(--c-primary-dark) 0%, #1e4d35 60%, #163d2a 100%);
  text-align: center;
}
.products-header__bg {
  position: absolute; inset: 0;
  background:
    radial-gradient(ellipse 60% 80% at 80% 50%, rgba(64,145,108,.22), transparent 60%),
    radial-gradient(ellipse 40% 60% at 10% 80%, rgba(212,160,23,.10), transparent 55%);
}
.products-header__eyebrow {
  display: inline-block; font-size: .72rem; font-weight: 600;
  letter-spacing: .2em; text-transform: uppercase;
  color: var(--c-accent); background: rgba(212,160,23,.14);
  padding: 5px 16px; border-radius: 100px; margin-bottom: 16px;
}
.products-header__title {
  font-family: var(--f-display); font-size: clamp(2.2rem, 5vw, 3.5rem);
  font-weight: 600; color: #fff; line-height: 1.15; margin-bottom: 12px;
}
.products-header__sub { font-size: .9rem; color: rgba(255,255,255,.58); font-weight: 300; letter-spacing: .06em; }

.about-layout { padding-top: 64px; padding-bottom: 80px; }
.about-section { margin-top: 72px; }

.about-eyebrow {
  display: inline-block; font-size: .72rem; font-weight: 600;
  letter-spacing: .2em; text-transform: uppercase;
  color: var(--c-primary-light); margin-bottom: 10px;
}
.about-section-title {
  font-family: var(--f-display); font-size: clamp(1.7rem, 3.5vw, 2.4rem);
  font-weight: 600; color: var(--c-primary-dark); line-height: 1.2; margin-bottom: 20px;
}
.about-body { font-size: .95rem; color: var(--c-muted); line-height: 1.75; }
.about-section-header { text-align: center; margin-bottom: 40px; }

/* INTRO */
.about-intro {
  display: grid; grid-template-columns: 340px 1fr; gap: 52px; align-items: center;
}
.about-intro__img-wrap {
  background: linear-gradient(135deg, #e8f5ec 0%, #d4e6d5 100%);
  border-radius: 20px; aspect-ratio: 1/1;
  display: flex; align-items: center; justify-content: center;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--c-border);
}
.about-intro__emoji { font-size: 7rem; }

.about-stats {
  display: flex; gap: 28px; margin-top: 28px; flex-wrap: wrap;
}
.about-stat { text-align: center; }
.about-stat__num {
  display: block; font-size: 1.5rem; font-weight: 600;  color: var(--c-primary);
}
.about-stat__label { font-size: .74rem; font-weight: 600; letter-spacing: .08em; text-transform: uppercase; color: var(--c-muted); }

/* MISSION & VISION */
.mv-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin-top: 56px; }
.mv-card {
  background: var(--c-surface); border: 1px solid var(--c-border);
  border-radius: var(--radius); padding: 36px;
  box-shadow: var(--shadow);
  transition: transform .28s var(--ease), box-shadow .28s;
}
.mv-card:hover { transform: translateY(-4px); box-shadow: var(--shadow-lg); }
.mv-card--accent { background: linear-gradient(135deg, var(--c-primary-dark), #1e4d35); color: #fff; border-color: transparent; }
.mv-card--accent .mv-card__title { color: #fff; }
.mv-card--accent .mv-card__body { color: rgba(255,255,255,.72); }
.mv-card__icon { font-size: 2.2rem; margin-bottom: 18px; }
.mv-card__title { font-family: var(--f-display); font-size: 1.6rem; font-weight: 600; color: var(--c-primary-dark); margin-bottom: 14px; }
.mv-card__body { font-size: .93rem; color: var(--c-muted); line-height: 1.72; }

/* WHY GRID */
.why-grid {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 22px;
}
.why-card {
  background: var(--c-surface); border: 1px solid var(--c-border);
  border-radius: var(--radius); padding: 28px 24px;
  box-shadow: var(--shadow);
  transition: transform .28s var(--ease), box-shadow .28s, border-color .28s;
  animation: cardIn .5s var(--ease) both;
  animation-delay: var(--delay, 0s);
  position: relative; overflow: hidden;
}
.why-card::before {
  content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px;
  background: linear-gradient(90deg, var(--c-primary), var(--c-primary-light));
  opacity: 0; transition: opacity .28s;
}
.why-card:hover { transform: translateY(-5px); box-shadow: var(--shadow-lg); border-color: var(--c-primary-light); }
.why-card:hover::before { opacity: 1; }
.why-card__icon { font-size: 2rem; margin-bottom: 14px; display: block; }
.why-card__title { font-family: var(--f-display); font-size: 1.15rem; font-weight: 600; color: var(--c-primary-dark); margin-bottom: 10px; }
.why-card__desc { font-size: .87rem; color: var(--c-muted); line-height: 1.65; }

/* TEAM */
.team-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 22px; }
.team-card {
  background: var(--c-surface); border: 1px solid var(--c-border);
  border-radius: var(--radius); padding: 32px 20px;
  text-align: center; box-shadow: var(--shadow);
  transition: transform .28s var(--ease), box-shadow .28s;
}
.team-card:hover { transform: translateY(-4px); box-shadow: var(--shadow-lg); }
.team-card__avatar { font-size: 3.5rem; margin-bottom: 14px; display: block; }
.team-card__name { font-family: var(--f-display); font-size: 1.15rem; font-weight: 600; color: var(--c-primary-dark); margin-bottom: 6px; }
.team-card__role { font-size: .77rem; font-weight: 600; letter-spacing: .07em; text-transform: uppercase; color: var(--c-primary-light); }

@keyframes cardIn { from { opacity:0; transform: translateY(20px); } to { opacity:1; transform: none; } }

@media (max-width: 860px) {
  .about-intro { grid-template-columns: 1fr; }
  .about-intro__img-wrap { max-width: 260px; margin: 0 auto; }
  .mv-grid { grid-template-columns: 1fr; }
}
`;
